import { AxiosResponse } from 'axios'
import { IFilter } from 'types/common'
import { api } from 'API'
import { IGroupProcess } from 'interfaces/process'

const BASE = '/groups-processes'

export async function getGroupsProcesses(filter: IFilter<IGroupProcess>): Promise<IGroupProcess[]> {
  const response: AxiosResponse = await api.get(`${BASE}?filter=${JSON.stringify(filter)}`)
  return response?.data ?? []
}
